import React from 'react'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import videoActions from 'redux/actions/videoActions'
import { localize } from 'helpers/translator'

const VideoCancelConfirm = props => (
	<Confirm
		btOne={localize('global_no')}
		btTwo={localize('global_yes')}
		alertMessage={localize('quiz_cancelConfirm')}
		actionButtonType={0}
		actionOne={props.actions.cancelReject}
		actionTwo={props.actions.cancelConfirm}
		closeAction={props.actions.cancelReject}
	/>
)

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		cancelReject: videoActions.cancelRejected,
		cancelConfirm: videoActions.cancelConfirmed,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(VideoCancelConfirm)
